<template>
  <div id="home" style="height: auto">
    <OilTypeCard />
    <div class="vx-row pl-2">
      <div class="flex-1 mx-1">
        <v-date-picker
          v-model="selectedDate"
          mode="date"
          is-range
          :locale="$i18n.locale"
          :buddhist="true"
          :max-date="new Date()"
          class="cursor-pointer"
        >
          <template v-slot="{ inputEvents }">
            <vs-button
              v-on="inputEvents.start"
              size="small"
              color="#fff"
              gradient-color-secondary="#fff" 
              type="gradient"
              class="w-full text-left cardDate"
            >
              <div class="vx-row">
                <div
                  class="vx-col text-center mt-2 pl-5 sm:w-1/3 lg:w-1/3 xl:w-1/3"
                >
                  <vs-icon color="#000" size="medium" icon="today"></vs-icon>
                </div>
                <div class="vx-col center sm:w-2/3 lg:w-2/3 xl:w-2/3">
                  <h6>{{ setFormat(selectedDate.start) }}</h6>
                  <hr class="mx-2 my-1" />
                  <h6>{{ setFormat(selectedDate.end) }}</h6>
                </div>
              </div>
            </vs-button>
          </template>
        </v-date-picker>
      </div>
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.ALL"
        :name="$t('totalOil')"
        :isActive="isAllCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume()"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.IRPC"
        :refineryID="REFINERY_ID.IRPC"
        :name="$t('RefineryIRPC')"
        :isActive="isIrpcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.IRPC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.SPRC"
        :refineryID="REFINERY_ID.SPRC"
        :name="$t('RefinerySPRC')"
        :isActive="isSprcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.SPRC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.TOP"
        :refineryID="REFINERY_ID.TOP"
        :name="$t('RefineryTOP')"
        :isActive="isTopCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.TOP)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.BCP"
        :refineryID="REFINERY_ID.BCP"
        :name="$t('RefineryBCP')"
        :isActive="isBcpCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.BCP)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.PTTGC"
        :refineryID="REFINERY_ID.PTTGC"
        :name="$t('RefineryPTTGC')"
        :isActive="isPttgcCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.PTTGC)"
        :isLoading="isVesselTripLoading"
      />
      <card-value
        class="flex-1 mx-1"
        :callback="setRefineryCard"
        :refineryName="REFINERY_NAME.ESSO"
        :refineryID="REFINERY_ID.ESSO"
        :name="$t('RefineryESSO')"
        :isActive="isEssoCardActive"
        :unit="$t('Liter')"
        :volume="this.getVolume(REFINERY_NAME.ESSO)"
        :isLoading="isVesselTripLoading"
      />
    </div>

    <div class="vx-row pl-2">
      <div class="vx-col w-full pl-5 pt-1 sm:w-5/5 lg:w-3/5 xl:w-3/5 pr-2">
        <div class="vx-row">
          <vx-card class="w-full">
            <DirectedtreeDmtEp />
            <bar-value-dmt-ep
              :enableTax="false"
              id="barChartdiv"
              :data="[
                `${getVolume(currentRefName)}`,
                `${formatNumber(Number(totalOilType).toFixed(2))}`,
                `0.00`,
                `${formatNumber(Number(totalOilType * 0.01).toFixed(2))}`,
              ]"
            />

            <vs-button
              color="dark"
              type="flat"
              class="fullScreenButton px-4 py-3"
              @click="popupDirectTree = true"
            >
              <vs-icon icon="crop_free"></vs-icon>
            </vs-button>
          </vx-card>
          <vs-popup fullscreen title :active.sync="popupDirectTree">
            <vx-card class="vx-col w-full" style="height: 100%">
              <DirectedtreeDmtEp style="height: 500px" />
              
              <bar-value-dmt-ep
                :enableTax="false"
                id="barChartdiv"
                :data="[
                  `${getVolume(currentRefName)}`,
                  `${formatNumber(Number(totalOilType).toFixed(2))}`,
                  `0.00`,
                  `${formatNumber(Number(totalOilType * 0.01).toFixed(2))}`,
                ]"
              />
            </vx-card>
          </vs-popup>
        </div>
        <div class="vx-row pt-2">
          <div class="w-full">
            <vx-card class="h-full">
              <vs-button
                color="dark"
                type="flat"
                class="fullScreenButton px-4 py-3"
                @click="popupChart = true"
              >
                <vs-icon icon="crop_free"></vs-icon>
              </vs-button>
              <h5 class="text-center">{{ $t("Graphics") }}</h5>
              <vs-tabs alignment="fixed">
                <vs-tab :label="$t('No') + ' 1'">
                  <RadarBar />
                </vs-tab>
                <vs-tab :label="$t('No') + ' 2'">
                  <SunBurst />
                </vs-tab>
                <vs-tab :label="$t('No') + ' 3'">
                  <StackedColumnChart
                    :dataStack="vesselTrip"
                    style="height: 400px"
                  />
                </vs-tab>
                <vs-tab :label="$t('No') + ' 4'">
                  <HighlightingChart :dataLine="vesselTrip" />
                </vs-tab>
                <vs-tab :label="$t('No') + ' 5'">
                  <OilTypeStackedColumnChart
                    :dataStack="vesselTrip"
                    style="height: 400px"
                  />
                </vs-tab>
              </vs-tabs>
            </vx-card>
            <vs-popup fullscreen title :active.sync="popupChart">
              <vx-card class="mt-2">
                <h5 class="text-center">{{ $t("Graphics") }}</h5>
                <vs-tabs alignment="fixed">
                  <vs-tab :label="$t('No') + ' 1'">
                    <RadarBar style="height: 480px" />
                  </vs-tab>
                  <vs-tab :label="$t('No') + ' 2'">
                    <SunBurst style="height: 530px" />
                  </vs-tab>
                  <vs-tab :label="$t('No') + ' 3'">
                    <StackedColumnChart
                      :dataStack="vesselTrip"
                      style="height: 480px"
                    />
                  </vs-tab>
                  <vs-tab :label="$t('No') + ' 4'">
                    <HighlightingChart
                      :dataLine="vesselTrip"
                      style="height: 480px"
                    />
                  </vs-tab>
                  <vs-tab :label="$t('No') + ' 5'">
                    <OilTypeStackedColumnChart
                      :dataStack="vesselTrip"
                      style="height: 480px"
                    />
                  </vs-tab>
                </vs-tabs>
              </vx-card>
            </vs-popup>
          </div>
        </div>
      </div>

      <div class="vx-col w-full pl-5 pt-1 sm:w-5/5 lg:w-2/5 xl:w-2/5 pl-0">
        <vx-card class="h-full">
          <vs-button
            color="dark"
            type="flat"
            class="fullScreenButton px-4 py-3"
            @click="popupTable = true"
          >
            <vs-icon icon="crop_free"></vs-icon>
          </vs-button>

          <div v-if="typeTanker == TANKER_TYPE.TANKER">
            <TankerTableDmtEp />
          </div>
          <div v-else >
            <RefineryTableDmtEp />
          </div>
          
        </vx-card>
        <vs-popup fullscreen class="holamundo" title :active.sync="popupTable">
          <vx-card class="mt-2" style="height: 50%">
            <div v-if="typeTanker == TANKER_TYPE.TANKER">
              <TankerTableDmtEp />
            </div>
            <div v-else >
              <RefineryTableDmtEp />
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import OilTypeCard from "@/components/Card/OilTypeCard.vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import StackedColumnChart from "@/components/charts/StackedColumnChart.vue";
import OilTypeStackedColumnChart from "@/components/charts/DomisticExport/OilTypeStackedColumnChart.vue";
import BarValueDmtEp from "@/common/BarValueDmtEx.vue";
import HighlightingChart from "@/components/charts/HighlightingChart.vue";
import RadarBar from "@/components/charts/RadarChart.vue";
import TankerTableDmtEp from "@/components/Table/DomisticExport/TankerTableDmtEp.vue";
import RefineryTableDmtEp from "@/components/Table/DomisticExport/RefineryTableDmtEp.vue";
import DirectedtreeDmtEp from "@/components/charts/DomisticExport/DirectedtreeDmtEp.vue";
import SunBurst from "@/components/charts/SunBurstChart.vue";
import { formatNumber } from "@/utils/index";
import CardValue from "@/common/Card/CardValue";
import {
  OIL_TYPE,
  REFINERY_NAME,
  REFINERY_ID,
  TANKER_TYPE,
} from "../../constants/index";
import _ from "lodash";

export default {
  name: "export",
  components: {
    BarValueDmtEp,
    StackedColumnChart,
    OilTypeStackedColumnChart,
    HighlightingChart,
    RadarBar,
    TankerTableDmtEp,
    RefineryTableDmtEp,
    DirectedtreeDmtEp,
    OilTypeCard,
    SunBurst,
    CardValue,
  },
  data() {
    return {
      totalOilType: "",
      REFINERY_NAME,
      REFINERY_ID,
      TANKER_TYPE,
      formatNumber,
      selectedDate: {
        start: new Date(),
        end: new Date(),
      },
      config: {
        startDate: moment().format("DD/MM/YYYY"),
        endDate: moment().format("DD/MM/YYYY"),
        destination_type: "export",
        isDomestic: "false",
      },
      popupDirectTree: false,
      popupChart: false,
      popupTable: false,
      fullscreen: false,
      isDisable: false,
      chart: null,
    };
  },
  async mounted() {
    await this.$store.dispatch("getOilType");
    await this.$store.dispatch("activeOilCard", OIL_TYPE.EXPORT_OIL);
    await this.$store.dispatch("petrol/getCountries");
    this.getVesselData();
  },
  watch: {
    typeTanker(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
      }
    },
    vesselTrip(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        // this.getVesselData();

        if (newValue[0].vessel_loads[0].destination_type == "export") {
          for (const oilDistribution of newValue) {
            let countries = ''
            for (const vesselLoad of oilDistribution.vessel_loads) {
              const countriesByid = _.find(this.countries, { 'id': vesselLoad.country_id})
              countries = countries != '' ? `${countries}/${countriesByid.to_s}` : `${countriesByid.to_s}`
            }
            oilDistribution.countries_to_s = countries
          }
        }

        console.log("newValue ", newValue);
      }
    },
    selectedDate(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        let newStartDate = this.setDateFormat(newValue.start);
        let newEndDate = this.setDateFormat(newValue.end);
        this.config.startDate = newStartDate;
        this.config.endDate = newEndDate;
        this.getVesselData();
      }
    },
    currentRefID(newValue, oldValue) {
      if (!_.isEqual(newValue, oldValue)) {
        let newStartDate = this.setDateFormat(this.selectedDate.start);
        let newEndDate = this.setDateFormat(this.selectedDate.end);
        this.config.startDate = newStartDate;
        this.config.endDate = newEndDate;
        this.config.station_id = this.currentRefID;
      }
    },
  },
  computed: {
    ...mapState({
      typeTanker: (state) => state.type,
      isAllCardActive: (state) => state.greenDieselCardActive.isAllCardActive,
      isIrpcCardActive: (state) => state.greenDieselCardActive.isIrpcCardActive,
      isSprcCardActive: (state) => state.greenDieselCardActive.isSprcCardActive,
      isTopCardActive: (state) => state.greenDieselCardActive.isTopCardActive,
      isBcpCardActive: (state) => state.greenDieselCardActive.isBcpCardActive,
      isPttgcCardActive: (state) =>
        state.greenDieselCardActive.isPttgcCardActive,
      isEssoCardActive: (state) => state.greenDieselCardActive.isEssoCardActive,
      currentRefID: (state) => state.vesselTrip.currentRefineryID,
      currentRefName: (state) => state.vesselTrip.currentRefineryName,
      vesselTrip: (state) => state.vesselTrip.data,
      isVesselTripLoading: (state) => state.vesselTrip.loading,
      oilType: (state) => state.vesselTrip.oilType,
      lastPriceOilType: (state) => state.priceOilType.lastPriceOilType,
      countries: (state) => state.petrol.countries,
    }),
    ...mapGetters({
      getStationValues: "getStationValues",
      getStationData: "getStationData",
      getterLastPriceOilType: "getterLastPriceOilType",
    }),
  },
  methods: {
    getOilPrice() {
      let totalOilPrice = _.chain(this.vesselTrip)
        .groupBy("vessel_loads.oil_type_id")
        .map((o, i) => {
          let id = "";
          let volume = 0;
          let totalPrice = 0;
          let data = [];
          let vesselLoads = _.chain(o)
            .map((o) => {
              let vesselLoad = _.get(o, "vessel_loads");
              let oilTypeId = _.chain(vesselLoad)
                .map((o) => {
                  let id = _.get(o, "oil_type_id");
                  let oilCategory = _.find(this.oilType, { id: id });
                  if (oilCategory != undefined) {
                    if (oilCategory.oil_category_id == "") {
                      return "HQ0000000004";
                    }
                    return oilCategory.oil_category_id;
                  } else {
                    return "HQ0000000004";
                  }
                })
                .value();

              let oilTypevolume = _.chain(vesselLoad)
                .map((o) => {
                  let volume = _.get(o, "volume");
                  return volume;
                })
                .value();
              return { oilTypeId, oilTypevolume };
            })
            .value();
            
          _.chain(vesselLoads)
            .map((o) => {
              for (let i = 0; i < o.oilTypeId.length; i++) {
                id = o.oilTypeId[i];
                volume = o.oilTypevolume[i];
                data.push({ id, volume });
              }
            })
            .value();

          let sumOilType = _.chain(data)
            .groupBy("id")
            .map(async(o, i) => {
              let id = i;

              let price = await this.getPrice(id);

              let sumPrice = _.reduce(
                o,
                (sum, a) => {
                  let volumes = Number(_.get(a, "volume"));
                  return sum + (volumes * price);
                },
                0
              );
              totalPrice = totalPrice + sumPrice;
              this.totalOilType = totalPrice;
              return { id, sumPrice };
            })
            .value();
        })
        .value();
      if (this.vesselTrip.length == 0) {
        this.totalOilType = 0;
      }
    },
    async getPrice(id) {
      await this.$store.dispatch("findPriceOilTypeLogByOilId", id);
      return this.getterLastPriceOilType;
    },
    setDateFormat(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    setFormat(date) {
      const locale = this.$i18n.locale;
      if (locale == "th") {
        const newDate = moment(date)
          .add(543, "years")
          .format("DD/MM/YYYY");
        return newDate;
      } else {
        const newDate = moment(date).format("DD/MM/YYYY");
        return newDate;
      }
    },
    setRefineryCard(refineryName, refineryID) {
      let newStartDate = this.setDateFormat(this.selectedDate.start);
      let newEndDate = this.setDateFormat(this.selectedDate.end);
      this.config.startDate = newStartDate;
      this.config.endDate = newEndDate;
      this.config.station_id = refineryID;
      this.getVesselData();
      this.$store.dispatch("activeRefineryCard", refineryName);
      // this.$store.dispatch("setRadar", refineryName);
      this.$store.dispatch("setCurrentRefName", refineryName);
      this.$store.dispatch("setCurrentRefID", refineryID);

      if (refineryName == REFINERY_NAME.ALL) {
        this.$store.dispatch("setType", "oil");
      } else {
        this.$store.dispatch("setType", "tanker");
        this.$store.dispatch("setTankerName", refineryName);
      }
    },
    getVolume(key) {
      const stationId = REFINERY_ID[key];
      const volume = formatNumber(this.getStationValues(stationId));
      return volume;
    },
    async getVesselData() {
      this.$vs.loading({});
      await this.$store.dispatch("getVesselVolume", this.config);
      await this.$store.dispatch("getVesselTrip", this.config);
      await this.getOilPrice();
      this.$vs.loading.close();
    },
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
    }
  },
};
</script>

<style lang="scss">
#home {
  .greet-user {
    position: relative;
    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }
    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {
    .decore-left,
    .decore-right {
      width: 140px;
    }
  }
}
#barChartdiv {
  position: absolute;
  top: 0px;
  left: 0px;
  margin: 8px;
}
#nopad {
  padding: 0 !important;
}
.chart {
  // width: 120%;
  height: 365px;
  font-family: "Prompt", sans-serif;
}
.hello2 {
  height: 500px;
}
.center {
  // width: 200px;
  margin: auto;
}
.red {
  background-color: red;
}
.green {
  background-color: green;
}
@keyframes stretch {
  from {
    transform: rotate(0deg) translateX(15px) rotate(0deg);
  }
  to {
    transform: rotate(360deg) translateX(15px) rotate(-360deg);
  }
}

/* The element to apply the animation to */
.Animatio {
  position: relative;
  animation-duration: 10s;
  animation: stretch 2s ease-out 0s infinite none running;
}
.setHeight {
  height: 100%;
}
.fullScreenButton {
  position: absolute;
  right: 0px;
  top: 0px;
}
.cardDate {
  height: 62px;
}
.boldText {
  font-weight: bold;
}
.active {
  background-color: #cccccc;
}
.green {
  background-color: red;
}
.lighten-1 {
  background-color: red;
}
.v-btn .v-btn--active {
  background-color: red;
}
.theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
  background-color: red;
}
</style>
